var isMobile = window.screen.width < 768;

(function () {
  var lastTime = 0;
  var vendors = ["ms", "moz", "webkit", "o"];

  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
    window.cancelRequestAnimationFrame = window[vendors[x] + "CancelRequestAnimationFrame"];
  }

  if (!window.requestAnimationFrame)
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };

  if (!window.cancelAnimationFrame)
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
})();

var layers = [],
  objects = [],
  world = document.getElementById("world"),
  viewport = document.getElementById("viewport"),
  d = 0,
  p = 500,
  worldXAngle = 0,
  worldYAngle = 0;

viewport.style.webkitPerspective = p;
viewport.style.MozPerspective = p;
viewport.style.oPerspective = p;

generate();

// ⭐ helper to avoid center spawning
function randomOutsideDeadZone(range, deadZone) {
  var val;
  do {
    val = range / 3 - Math.random() * range;
  } while (Math.abs(val) < deadZone);
  return val;
}

function createCloud() {
  var div = document.createElement("div");
  div.className = "cloudBase";

  // ⭐ avoid center when placing full cloud clusters
  var x = randomOutsideDeadZone(900, 120);
  var y = randomOutsideDeadZone(900, 10);
  var z = 256 - Math.random() * 512;

  var t = "translateX(" + x + "px) translateY(" + y + "px) translateZ(" + z + "px)";

  div.style.webkitTransform = div.style.MozTransform = div.style.msTransform = div.style.oTransform = div.style.transform = t;

  world.appendChild(div);

  for (var j = 0; j < 10 + Math.round(Math.random() * 14); j++) {
    var cloud = document.createElement("div");
    cloud.style.opacity = 0.7;
    cloud.className = "cloudLayer";

    // ⭐ smaller tighter cloud pieces
    var x = 120 - Math.random() * 240;
    var y = 120 - Math.random() * 240;
    var z = 60 - Math.random() * 120;

    var a = Math.random() * 360;

    // ⭐ smaller scale range
    var s = 0.2 + Math.random() * 0.32;

    x *= 0.35;
    y *= 0.35;

    cloud.data = {
      x: x,
      y: y,
      z: z,
      a: a,
      s: s,
      speed: 0.045 + Math.random() * 0.075,
    };

    var t = "translateX(" + x + "px)" + " translateY(" + y + "px)" + " translateZ(" + z + "px)" + " rotateZ(" + a + "deg)" + " scale(" + s + ")";

    cloud.style.webkitTransform = cloud.style.MozTransform = cloud.style.msTransform = cloud.style.oTransform = cloud.style.transform = t;

    div.appendChild(cloud);
    layers.push(cloud);
  }

  return div;
}

function generate() {
  objects = [];

  if (world.hasChildNodes()) {
    while (world.childNodes.length >= (isMobile ? 12 : 12)) {
      world.removeChild(world.firstChild);
    }
  }

  // ⭐ still high density but slightly reduced
  for (var j = 0; j < (isMobile ? 12 : 24); j++) {
    objects.push(createCloud());
  }
}

function updateView() {
  var t = "translateZ(" + d + "px) rotateX(" + worldXAngle + "deg) rotateY(" + worldYAngle + "deg)";
  world.style.webkitTransform = world.style.MozTransform = world.style.msTranform = world.style.oTransform = world.style.transform = t;
}

function update() {
  for (var j = 0; j < layers.length; j++) {
    var layer = layers[j];
    layer.data.a += layer.data.speed;

    var t = "translateX(" + layer.data.x + "px)" + " translateY(" + layer.data.y + "px)" + " translateZ(" + layer.data.z + "px)" + " rotateY(" + -worldYAngle + "deg)" + " rotateX(" + -worldXAngle + "deg)" + " rotateZ(" + layer.data.a + "deg)" + " scale(" + layer.data.s + ")";

    layer.style.webkitTransform = layer.style.MozTransform = layer.style.msTranform = layer.style.oTransform = layer.style.transform = t;
  }

  requestAnimationFrame(update);
}

update();
